<template>
  <div class="collapse-panel">
    <div
      class="collapse-panel__header"
      :class="headerClass"
      @click="isOpenSync = !isOpenSync">
      <div class="collapse-panel__header__content" :class="headerContentClass">
        <slot name="header"/>
      </div>
      <div class="collapse-panel__header__chevron" :class="headerChevronClass">
        <font-awesome-icon :class="chevronClass" :icon="['fas', 'chevron-right']" />
      </div>
    </div>
    <el-collapse-transition>
      <div class="collapse-panel__body" :class="bodyClass" v-show="isOpen">
        <div :class="borderClass"></div>
        <slot name="body"/>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'collapsePanel',
  emits: ['update:is-open'],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    bodyClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    headerChevronClass: {
      type: String,
      default: '',
    },
    headerContentClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },
      set(isOpen) {
        this.$emit('update:is-open', isOpen);
      },
    },
    chevronClass() {
      return {
        'collapse-panel__header__chevron__icon': true,
        'collapse-panel__header__chevron__icon--rotate': this.isOpen,
      };
    },
    borderClass() {
      return {
        'collapse-panel__body__border': this.border,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.collapse-panel {
  border-radius: var(--nxt-border-radius-base);
  background-color: var(--nxt-color-light-grey);
  &__header {
    padding: 20px;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    &__chevron {
      margin: auto 0 auto 20px;
      &__icon {
        transition: transform 0.25s linear;
        &--rotate {
          transform: rotate(-90deg);
        }
      }
    }
  }
  &__body {
    padding: 0 20px 20px 20px;
    &__border {
      border-top: solid 1px var(--nxt-color-grey);
    }
  }
}
</style>
